










import Vue from 'vue'
import User from '@/types/User.interface'
import VerificationForm from '@/components/VerificationForm.vue'
import Analytics from '@/services/Analytics'
export default Vue.extend({
    components: { VerificationForm },
    data() {
        return {
            //  Flag that determines we are creating a stripe customer
            creating: false,
            // Flag that determines if we've already resent an email verification code
            sentEmailOnce: false,
            // Flag that determines if a user is being verified
            processing: false,
            // Quote Line 1 Text for VerificationForm component
            quoteLine1: 'Did you know only 6% of emails get responded to',
            // Quote Line 2 Text for VerificationForm component
            quoteLine2: 'Compare that to 98% response rates for Text messaging',
            // The error message that appears on the the verification input
            errorMessage: null
        }
    },
    created() {
        // If the user is verified and registered, proceed registration
        if (this.verified && this.registered) {
            this.$router.push(`/register/verifysms${this.query || ''}`)
        }
        //  If verified but not registered, create stripe customer
        else if (this.verified && !this.registered) {
            this.registerStripeCustomer()
        }
    },
    async mounted() {
        //  If not verified, send the email code
        if (!this.verified) this.$store.dispatch('authVerifyEmailSend')
    },
    computed: {
        query(): string | null {
            //  If query params exist, return string format
            if (this.$route.query) return '?' + window.toUrlParams(this.$route.query)
            //  Else, return nothing
            return null
        },
        registered(): boolean {
            //  Check if the user has a stripe id
            const stripeID = this.user.stripe_customer_id

            // If the stripe id is not empty, return true
            if (stripeID) return true

            //  Else, look for user memberships
            const registered = this.user.memberships.length

            //  If it exists, return true
            if (registered) return true

            //  Else, return false
            return false
        },
        user(): User {
            return this.$store.getters.user
        },
        verified(): boolean {
            return this.user.email_verified
        }
    },
    methods: {
        changeEmail(): void {
            //  If verified, do nothing
            if (this.verified) return

            //  Display edit form
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Change email address',
                icon: 'mdi-pencil',
                color: 'primary',
                closeable: true,
                component: 'app-form',
                callback: (user: User) => this.userUpdate(user),
                props: {
                    model: this.user,
                    inputs: [
                        {
                            type: 'TEXT',
                            name: 'Email',
                            label: 'Email',
                            path: 'email',
                            validate: 'email|userEmailUnique',
                            delay: '1000'
                        }
                    ]
                }
            })
        },
        confirmResend(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: `Email a new code?`,
                text: `Do you want to send a new verification code to <b>${this.user.email}</b>?`,
                icon: 'mdi-alert',
                color: 'yellow darken-2',
                callback: (result: boolean) => this.resend(result)
            })
        },
        onResendEmailVerification(): void {
            return this.sentEmailOnce ? this.confirmResend() : this.resend(true)
        },
        async onSubmit(code: number): Promise<void> {
            // Indicate that we are proccessing verification
            this.processing = true

            // Reset the error message
            this.errorMessage = null

            //  Create our payload
            const payload = {
                code: code,
                user_id: this.user.id
            }

            //  Submit email code
            const response = await this.$store.dispatch('authVerifyEmail', payload)

            //  If response failed, set error
            if (!response) {
                this.errorMessage = 'Oops! That’s the wrong code. Please try again'
                this.processing = false
                return
            }

            //  Send segment payload and event name so we can track this workflow
            Analytics.segmentTrack('UserEmailVerified')
        },
        async registerStripeCustomer(): Promise<void> {
            // Ensure that the customer is verified before registering in stripe
            if (!this.verified) return

            //  Make sure we only do this once
            if (this.creating) return

            //  Set our flag to true so we don't get duplicates
            this.creating = true

            // Indicate that we are creating the stripe customer
            this.processing = true

            //  Create stripe customer
            const customer = await this.$store.dispatch('stripeCustomerPost')

            //  If no customer, do nothing
            if (!customer) return

            // If phone and email are verified naviagate to the use-case form
            this.$router.push(`/register/verifysms${this.query || ''}`)
        },
        async resend(dialog_result: boolean): Promise<void> {
            //  If the request is not confirmed, do nothing
            if (!dialog_result) return

            //  Send a verification code to the authenticated user's phone
            const sent = await this.$store.dispatch('authVerifyEmailSend')

            //  If the verification code was NOT sent, do nothing
            if (!sent) return

            //  Else, notify the user of successfully sent verification code to their device
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Verification Code Sent',
                text: `A new verification code has been sent to ${this.user.email}.`,
                icon: 'mdi-check-circle',
                color: 'primary'
            })

            //  Remember the user has resent a code at least once, this tiggers a confirm on the second send
            this.sentEmailOnce = true
        },
        async userUpdate(user: User): Promise<void> {
            // Update the user
            user = await this.$store.dispatch('authUserPut', user)

            // Close the dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  If the request failed, do nothing
            if (!user) return

            //  After changing the auth user's phone or email, resend their invitation
            this.resend(true)
        }
    },
    watch: {
        verified(isVerified: boolean): void {
            // If the user is verified and registerd, proceed registration
            if (isVerified && this.registered) {
                this.$router.push(`/register/verifysms${this.query || ''}`)
            }
            // Otherwise, register the stripe customer
            else {
                this.registerStripeCustomer()
            }
        }
    }
})
